import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class KneServicesService {

  constructor( private apiService: ApiService ) { }

  getAllContents(): Observable<[string]> {
    return this.apiService.getwp('/service/')
        .map(data => data);
  }
  
}



// WEBPACK FOOTER //
// ./src/app/shared/services/kne-services.service.ts